import { baseUrl } from "../../helpers/constants";
import { fetchWrapper } from "../../helpers/fetchwrapper";
import { IProduktDto } from "../../Models/IProdukt";
import { IUserProduct } from "../../Models/IUserProduct";

export const hasRightsForUrl = (
  isPartnerLounge: boolean,
  isToolbox: boolean
): Promise<boolean | undefined> => {
  return fetchWrapper
    .getWithAuth(`${baseUrl}/api/account/getmyroles`)
    .then((roles: string[]) => {
      if (roles && roles.includes("Partner") && roles.includes("Toolbox")) {
        // Benutzer hat beide Rollen hinterlegt, prüfen ob Vertriebsdamin oder Admin!
        if (!roles.includes("Admin") && !roles.includes("Vertriebsadmin")) {
          return false;
        }
      } else if (roles && !roles.includes("Partner") && isPartnerLounge) {
        return false;
      } else if (roles && !roles.includes("Toolbox") && isToolbox) {
        // Keins von beiden, auf die Startseite gehen!
        return false;
      } else {
        return true;
      }
    })
    .catch((error) => {
      // Bei einem Fehler sofort auf die Startseite gehen!
      return false;
    })
    .finally(() => {
      return true;
    });
};

export const getProductByUserProductGuid = (
  guid: string
): Promise<IProduktDto | undefined> => {
  return fetchWrapper
    .getWithAuth(
      `${baseUrl}/api/UserProduct/getProductByUserProductGuid?guid=${guid}`
    )
    .then((result: IProduktDto) => {
      return result;
    })
    .catch((error) => {
      return undefined;
    });
};

export const updateUserProduct = (
  userProduct: IUserProduct
): Promise<boolean> => {
  return fetchWrapper
    .postWithAuth(`${baseUrl}/api/UserProduct/Edit`, userProduct)
    .then((result: any) => {
      return true;
    })
    .catch((error) => {
      return false;
    });
};
